import topics from './topics'

export default
{
    topics
};
